<template>
    <v-container :key="keySincronizacao">
        <h1 class="titulo mb-3">Carga de informações</h1>
        <v-card class="card">
            <v-card-text>
                <!-- Finalizou com sucesso -->
                <div v-if="finalizado && rotina_executando.msg_erro === null" class="text-center py-6">
                    <v-icon size="100" color="success">check_circle_outline</v-icon>
                    <h2 class="text--success">Carga de informações realizada com sucesso!</h2>
                    <v-btn color="secondary" class="mt-6" @click="voltar()">Voltar</v-btn>
                </div>
                <!-- Finalizou com erro -->
                <div v-else-if="finalizado && rotina_executando.msg_erro !== null" class="text-center py-6">
                    <v-icon size="100" color="error">error</v-icon>
                    <h2 class="text--error">Não foi possível realizar a carga de informações no momento.</h2>
                    <p class="mt-3">Código para suporte: <strong>{{ rotina_executando.id_carga_informacoes }}</strong></p>
                    <p class="mt-3" v-if="rotina_executando.msg_erro == erro_timeout_newcon">Os serviços Newcon demoraram muito para responder. Tente novamente mais tarde.</p>
                    <v-btn color="secondary" class="mt-6" @click="voltar()">Voltar</v-btn>
                </div>
                <div v-else>
                    <!-- Tem uma rotina para ser executada -->
                    <div v-if="rotina_executando.id_carga_informacoes !== null">
                        <div class="d-flex justify-space-between align-center mb-6">
                            <h2>
                                Carga de informações em execução
                                <v-chip
                                        class="ma-2"
                                        :color="rotina_executando.status === 'pendente' ? 'warning' : 'success'"
                                        text-color="white">
                                    <v-avatar left>
                                        <v-icon v-if="rotina_executando.status === 'pendente'">pause_circle_outline</v-icon>
                                        <v-icon v-if="rotina_executando.status === 'executando'">play_circle_outline</v-icon>
                                    </v-avatar>
                                    {{ rotina_executando.status === 'pendente' ? 'Pendente' : 'Executando' }}
                                </v-chip>
                                <v-chip
                                        class="ma-2"
                                        color="error"
                                        style="cursor:pointer"
                                        text-color="white"
                                        @click="dialogCancelarCarga"
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-close-circle-outline</v-icon>
                                    </v-avatar>
                                    Cancelar
                                </v-chip>
                            </h2>
                            <span class="text-body-h5">Tempo transcorrido: {{ tempoTranscorridoSyncAtual }}</span>
                        </div>
                        <p>Atualização da lista de preço</p>
                        <v-progress-linear
                                color="primary"
                                height="30"
                                :value="Math.ceil(rotina_executando.lista_preco_concluido)"
                                class="mb-8">
                            <template v-slot="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                        <p>Atualização de novos planos de venda</p>
                        <v-progress-linear
                                color="primary"
                                height="30"
                                :value="Math.ceil(rotina_executando.prazos_grupos_cotas_concluido)"
                                class="mb-8">
                            <template v-slot="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                        <p>Atualização de novos grupos</p>
                        <v-progress-linear
                                color="primary"
                                height="30"
                                :value="Math.ceil(rotina_executando.novos_grupos_concluido)"
                                class="mb-8">
                            <template v-slot="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                        <p>Atualização de cotas vagas</p>
                        <v-progress-linear
                                color="primary"
                                height="30"
                                :value="Math.ceil(rotina_executando.novas_cotas_concluido)"
                                class="mb-8">
                            <template v-slot="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </div>
                    <!-- Não tem uma rotina para ser executada -->
                    <div v-else>
                        <h2>
                            Informe os dados abaixo para realizar a carga
                        </h2>
                        <v-form ref="form" class="mt-6" @submit.prevent="sincronizar()">
                            <v-row>
                                <v-col>
                                    <Autocomplete label="Empresas:"
                                                  class="required"
                                                  :rules="[$rules.required]"
                                                  :items="empresas"
                                                  v-model="empresas_selecionadas"
                                                  item-text="label"
                                                  item-value="id_empresa"
                                                  placeholder="Selecione as empresas"
                                                  :max-items="MAX_EMPRESAS"
                                                  multiple />
                                </v-col>
                                <v-col>
                                    <Autocomplete label="Unidades de negócio:"
                                                  class="required"
                                                  :rules="[$rules.required]"
                                                  :items="unidades"
                                                  v-model="unidades_selecionadas"
                                                  item-text="label"
                                                  item-value="id_unidade"
                                                  placeholder="Selecione as unidades de negócio"
                                                  :max-items="MAX_UNIDADES"
                                                  multiple />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <Autocomplete label="Produtos:"
                                                  class="required"
                                                  :rules="[$rules.required]"
                                                  :items="produtos"
                                                  v-model="produtos_selecionados"
                                                  item-text="label"
                                                  item-value="id_produto"
                                                  placeholder="Selecione os produtos"
                                                  :max-items="MAX_PRODUTOS"
                                                  multiple />
                                </v-col>
                                <v-col>
                                    <Autocomplete label="Planos de venda:"
                                                  class="required"
                                                  :rules="[$rules.required]"
                                                  :items="planos"
                                                  v-model="planos_selecionados"
                                                  item-text="label"
                                                  item-value="id_plano_venda"
                                                  placeholder="Selecione os planos de venda"
                                                  :max-items="MAX_PLANOS_VENDA"
                                                  multiple />
                                </v-col>
                            </v-row>
                            <v-flex class="text-center">
                                <v-btn color="primary" type="submit">Sincronizar</v-btn>
                            </v-flex>
                        </v-form>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { get } from 'lodash'
  import { alert, notification, sleep } from '@/plugins/helpers'
  import { CargaInformacoesStatus, erro_timeout_newcon } from '@/plugins/constants'
  import { AlertTypes } from '../../plugins/alerts_types'
  const NUMERO_OPERACOES_CARGA_UNICA = 4
  const rotina_vazia = () => ({
    id_carga_informacoes: null,
    lista_preco_concluido: null,
    prazos_grupos_cotas_concluido: null,
    novos_grupos_concluido: null,
    status: null,
    msg_erro: null,
    data_hora_criacao: null,
    carga_informacoes_empresas: [],
    carga_informacoes_unidade_negocio: [],
    carga_informacoes_produto: [],
    carga_informacoes_plano_venda: []
  })
  export default {
    name: 'Sincronizacao',
    data: () => ({
      keySincronizacao: 1,
      ja_exibiu_alerta_cancelar: false,
      rotina_andamento: [],
      empresas_selecionadas: [],
      empresas_nomes: [],
      unidades_selecionadas: [],
      unidades_nomes: [],
      produtos_selecionados: [],
      produtos_nomes: [],
      planos_selecionados: [],
      planos_nomes: [],
      tempoMaximoRecomendadoCarga: 8,
      rotina_executando: rotina_vazia(),
      erro_timeout_newcon: erro_timeout_newcon,
      tempoTranscorrido: ''
    }),
    computed: {
      tempoMaximoRecomendadoCargaCalculado () {
        if (this.rotina_executando.carga_informacoes_empresas.length <= 1 &&
          this.rotina_executando.carga_informacoes_unidade_negocio.length <= 1 &&
          this.rotina_executando.carga_informacoes_produto.length <= 1 &&
          this.rotina_executando.carga_informacoes_plano_venda.length <= 1) {
          return this.tempoMaximoRecomendadoCarga
        }
        const operacoesTotais = this.rotina_executando.carga_informacoes_empresas.length + this.rotina_executando.carga_informacoes_unidade_negocio.length + this.rotina_executando.carga_informacoes_produto.length + this.rotina_executando.carga_informacoes_plano_venda.length
        const operacoesSobrantes = operacoesTotais - NUMERO_OPERACOES_CARGA_UNICA
        const tempoCalculado = operacoesSobrantes > 0 ? (this.tempoMaximoRecomendadoCarga + (operacoesSobrantes * (this.tempoMaximoRecomendadoCarga / 2))) : this.tempoMaximoRecomendadoCarga
        return tempoCalculado
      },
      tempoTranscorridoSyncAtual () {
        return this.tempoTranscorrido
      },
      empresas () {
        const empresas = this.$session.get('empresas').map(empresa => ({ id_empresa: empresa.ID_Empresa, nome: empresa.NM_Empresa.toUpperCase(), label: `${empresa.CD_Empresa} - ${empresa.NM_Empresa}` }))
        return empresas.sort(this.ordernar)
      },
      unidades () {
        const unidades = this.$session.get('unidades').map(unidade => ({ id_unidade: unidade.id_unidade_negocio, nome: unidade.nm_unidade_negocio, label: `${unidade.cd_unidade_negocio} - ${unidade.nm_unidade_negocio.toUpperCase()}` }))
        return unidades.sort(this.ordenar)
      },
      produtos () {
        const produtos = this.$session.get('produtos').map(produto => ({ id_produto: produto.ID_Produto, nome: produto.NM_Produto.toUpperCase(), label: `${produto.CD_Produto} - ${produto.NM_Produto.toUpperCase()}` }))
        return produtos.sort(this.ordenar)
      },
      planos () {
        const planos = this.$session.get('planos_venda').map(plano => ({ id_plano_venda: plano.ID_Plano_Venda, nome: plano.NM_Plano_Venda, label: `${plano.CD_Plano_Venda} - ${plano.NM_Plano_Venda.toUpperCase()}` }))
        return planos.sort(this.ordenar)
      },
      MAX_EMPRESAS: () => 5,
      MAX_UNIDADES: () => 5,
      MAX_PRODUTOS: () => 3,
      MAX_PLANOS_VENDA: () => 5,
      finalizado () { return this.rotina_executando.status === CargaInformacoesStatus.Finalizado }
    },
    async beforeMount () {
      setInterval(() => {
        this.updateTime()
      }, 1000)
      this.tempoMaximoRecomendadoCarga = await this.getTempoMaximoRecomendadoCarga()
      let rotina_andamento = await this.getRotinaEmAndamento()
      if (rotina_andamento) {
        this.rotina_andamento = rotina_andamento
        await this.getStatus(rotina_andamento.id_carga_informacoes)
      }
    },
    methods: {
      async getTempoMaximoRecomendadoCarga () {
        return this.$http.get('/painel/configuracao_tempo_carga').then((response) => {
          return response.data.tempo_recomendado_carga
        }).catch((err) => {
          console.error(err)
        })
      },
      ordenar (a, b) {
        if (a.nome < b.nome) return -1
        if (a.nome > b.nome) return 1
        return 0
      },
      async updateTime () {
        if (!this.rotina_executando.data_hora_criacao) {
          this.tempoTranscorrido = ''
          return
        }
        const diff = new Date() - new Date(this.rotina_executando.data_hora_criacao)
        const segundosTranscorridos = Math.floor(diff / 1000)
        let minutosTranscorridos = Math.floor(segundosTranscorridos / 60)
        if (this.tempoMaximoRecomendadoCargaCalculado <= minutosTranscorridos && !this.ja_exibiu_alerta_cancelar) {
          this.ja_exibiu_alerta_cancelar = true
          notification(AlertTypes.WARN, 'O tempo previsto para a carga foi extrapolado, sugerimos cancelar a carga de informações e tentar novamente.')
        }
        if (minutosTranscorridos < 10) {
          minutosTranscorridos = '0' + minutosTranscorridos
        }
        let segundosRestantes = segundosTranscorridos % 60
        if (segundosRestantes < 10) {
          segundosRestantes = '0' + segundosRestantes
        }
        this.tempoTranscorrido = `${minutosTranscorridos}:${segundosRestantes}`
      },
      dialogCancelarCarga () {
        alert({
          text: 'Gostaria de cancelar a carga de informações?',
          buttons: {
            'Cancelar': () => { },
            'Confirmar': () => this.cancelarCargaInformacoes()
          }
        })
      },
      async resetarComponente () {
        const tempoMaximoRecomendadoCarga = this.tempoMaximoRecomendadoCarga
        Object.assign(this.$data, this.$options.data.call(this))
        this.tempoMaximoRecomendadoCarga = tempoMaximoRecomendadoCarga
        this.keySincronizacao++
        this.voltar()
      },
      async cancelarCargaInformacoes () {
        await this.$http.post('/painel/cancelar-carga-informacoes').then(() => {
          notification(AlertTypes.SUCCESS, 'Sucesso ao cancelar a carga!')
          this.resetarComponente()
        }).catch(() => {
          notification(AlertTypes.ERROR, 'Erro no cancelamento da carga, tente novamente e se o problema persistir entre em contato com a Área de Suporte.')
        })
      },
      sincronizar () {
        const form = this.$refs.form

        this.empresas_nomes = []
        this.unidades_nomes = []
        this.produtos_nomes = []
        this.planos_nomes = []

        let empresas_nomes = this.empresas_nomes
        let unidades_nomes = this.unidades_nomes
        let produtos_nomes = this.produtos_nomes
        let planos_nomes = this.planos_nomes

        if (form.validate()) {
          this.empresas_selecionadas.forEach(id_empresa => {
            this.empresas.forEach((empresa) => {
              if (empresa.id_empresa === id_empresa) {
                this.empresas_nomes.push(empresa.label)
              }
            })
          })

          this.planos_selecionados.forEach(id_plano => {
            this.planos.forEach((plano) => {
              if (plano.id_plano_venda === id_plano) {
                this.planos_nomes.push(plano.label)
              }
            })
          })

          this.produtos_selecionados.forEach(id_produto => {
            this.produtos.forEach((produto) => {
              if (produto.id_produto === id_produto) {
                this.produtos_nomes.push(produto.label)
              }
            })
          })

          this.unidades_selecionadas.forEach(id_unidade => {
            this.unidades.forEach((unidade) => {
              if (unidade.id_unidade === id_unidade) {
                this.unidades_nomes.push(unidade.label)
              }
            })
          })

          this.$http.post('painel/carga_informacoes', {
            log: { empresas_nomes: empresas_nomes, unidades_nomes: unidades_nomes, produtos_nomes: produtos_nomes, planos_nomes: planos_nomes },
            empresas: this.empresas_selecionadas,
            unidades_negocio: this.unidades_selecionadas,
            produtos: this.produtos_selecionados,
            planos_venda: this.planos_selecionados,
            id_comissionado: this.$session.get('id_comissionado_master')
          })
            .then((res) => {
              this.getStatus(res.data.id_carga_informacoes)
            }).catch(err => {
              let msg_string = 'Não foi possível realizar a sincronização'

              const msg = get(err, 'response.data.Msg_Erro', false)
              if (msg) {
                try {
                  const msg_json = JSON.parse(msg)
                  msg_string = Object.keys(msg_json).map(item => msg_json[item]).join('\n')
                } catch (e) {
                  notification('error', err, msg_string)
                  return
                }
              }
              alert(msg_string)
            })
        }
      },
      async getStatus (id_carga_informacoes) {
        let is_first_try = true
        while ((this.rotina_executando.status !== CargaInformacoesStatus.Finalizado && this.rotina_executando.id_carga_informacoes > 0) || is_first_try) {
          if (this.$http) { // Prevent undefined var.
            // Só mostra o loading caso seja a primeira vez que fez a requisição, quando está no loop ele nao mostra mais o loading.
            const res = await this.$http.get(`painel/carga_executando/${id_carga_informacoes}`, { options: { silent: !is_first_try } })
            if (res.data.carga_executando) {
              this.rotina_executando = res.data.carga_executando
            } else {
              this.rotina_executando = rotina_vazia()
            }
            this.updateTime()
          }

          if (is_first_try) is_first_try = false

          sleep(1000 * 60)
        }
      },
      async getRotinaEmAndamento () {
        const res = await this.$http.get(`painel/carga_executando/${0}`)
        return res.data.carga_executando
      },
      voltar () {
        this.rotina_executando = rotina_vazia()
        this.empresas_selecionadas = []
        this.unidades_selecionadas = []
        this.produtos_selecionados = []
        this.planos_selecionados = []
      }
    }
  }
</script>

<style scoped></style>
